import angular from 'angular'

import ggsAttr from '../ggs-attr'
import ggsUtils from '../utils'
import ggsIcons from '../ggs-icons'
import ggsLocale from '../ggs-locale'
import ggsHaltClick from '../ggs-halt-click'
import ggsFastSwitch from '../ggs-fast-switch'
import ggsHighlighter from '../ggs-highlighter'
import ggsRecalcOnevent from '../ggs-recalc-onevent'

import ggsGalleryUser from '../gallery-user'
import ggsGalleryVoteCount from '../gallery-vote-count'
import ggsGalleryTextPreview from './gallery-text-preview'
import ggsGalleryThumbPreview from './gallery-thumb-preview'

export default angular
  .module('ggs.gallery-preview', [
    ggsAttr,
    ggsUtils,
    ggsIcons,
    ggsLocale,
    ggsHaltClick,
    ggsFastSwitch,
    ggsHighlighter,
    ggsRecalcOnevent,

    ggsGalleryUser,
    ggsGalleryVoteCount,
    ggsGalleryTextPreview,
    ggsGalleryThumbPreview
  ])
  .name
